import { Stack } from '@kiwicom/orbit-components';
import { Check } from '@kiwicom/orbit-components/icons';
import { FormattedMessage } from 'react-intl';

import Text from './Text';

type Props = {
  readonly translationIds: readonly string[];
};

const CheckLine = ({ children }: { readonly children: JSX.Element }) => {
  return (
    <Stack flex spacing="200" align="center">
      <Check color="success" />
      <Text>{children}</Text>
    </Stack>
  );
};

const CheckList = (props: Props): JSX.Element => {
  return (
    <>
      {props.translationIds.map((id) => (
        <CheckLine key={id}>
          <FormattedMessage id={id} />
        </CheckLine>
      ))}
    </>
  );
};

export default CheckList;
